import React, { useState, useEffect } from 'react';
import {
  Container,
  Button,
  Typography,
  TextField,
  CircularProgress,
  Paper,
  Box,
  InputAdornment,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TablePagination
} from '@mui/material';
import {
  Search,
  AddCircleOutline,
  Settings,
  Edit,
  Delete
} from '@mui/icons-material';
import {
  obtenerTiposCampanas,
  eliminarTc,
} from '../../../actions/CampanasAction';
import { useStateValue } from '../../../contexto/store';

const TipoCampanaTb = (props) => {
  //eslint-disable-next-line
  const [{ openSnackar }, dispatch] = useStateValue();
  const [Datar, setDatar] = useState([]);
  const [term, setTerm] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [campanaElimNombre, setCampanaElimNombre] = useState('');
  const [campanaElimId, setCampanaElimId] = useState(null);
  const [datosCargados, setDatosCargados] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  //TRAER LOS DATOS AL CARGAR EL COMPONENTE
  useEffect(() => {
    obtenerTiposCampanas().then((response) => {
      const Data = response.data;
      setDatar(Data);
      setDatosCargados(true);
    });
  }, []);

  //RRR: FUNCION BUSCAR DE TABLA
  function searchingTerm(term) {
    return function (x) {
      let descritipocampana = x.descritipocampana || '';
      let codtipocampana = x.codtipocampana || 0;

      return (
        descritipocampana.toLowerCase().includes(term) ||
        codtipocampana.toString().toLowerCase().includes(term) ||
        !term
      );
    };
  }

  //RRR: FUNCION ONCLICK(SELECCIONAR TIPO CAMPANA) DE TABLA
  const seleccionarTipoCampana = (tipocampana) => {
    props.history.push({
      pathname: '/tipocampana/modificar',
      state: tipocampana,
    });
  };

  //RRR: FUNCION ONCLICK DE BOTON NUEVO
  const nuevoTipoCampana = () => {
    props.history.push('/tipocampana/nuevo');
  };

  //MOSTRAR DIALOGO DE CONFIRMACION PARA ELIMINAR
  const mostrarDialogEliminar = (tipocampanaelim) => {
    setCampanaElimNombre(tipocampanaelim.descritipocampana);
    setOpenDialog(true);
    setCampanaElimId(tipocampanaelim.tipocampanA_Id);
  };

  const dialogHandleCloseX = (e) => {
    setOpenDialog(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //RRR: FUNCION PARA ELIMINAR TIPO DE CAMPAÑA
  const eliminarTipoCampana = () => {
    eliminarTc(campanaElimId).then((response) => {
      if (response.status === 200) {
        window.location.reload();
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se elimino exitosamente el Tipo de Campana',
          },
        });
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje:
              'El Tipo de Campana ya esta siendo utilizado no se puede eliminar ',
          },
        });
      }
    });
  };

  const tiposFiltrados = Datar.filter(searchingTerm(term));

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Header moderno con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(10px)',
              }}
            >
              <Settings sx={{ fontSize: 32, color: 'white' }} />
            </Box>
            <Box>
              <Typography variant="h4" sx={{ color: 'white', fontWeight: 600, mb: 0.5 }}>
                Tipos de Campañas
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Chip 
                  label={`${Datar.length} tipo${Datar.length === 1 ? '' : 's'} registrado${Datar.length === 1 ? '' : 's'}`}
                  size="small"
                  sx={{ 
                    backgroundColor: 'rgba(255,255,255,0.2)', 
                    color: 'white',
                    fontWeight: 500,
                    backdropFilter: 'blur(10px)',
                  }}
                />
              </Box>
            </Box>
          </Box>
          
          <Button
            variant="contained"
            startIcon={<AddCircleOutline />}
            onClick={nuevoTipoCampana}
            sx={{
              backgroundColor: 'white',
              color: '#0d47a1',
              fontWeight: 600,
              px: 3,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.9)',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            Nuevo Tipo
          </Button>
        </Box>
      </Paper>

      {/* Barra de búsqueda moderna */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por descripción o código..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'background.default',
              '&:hover': {
                backgroundColor: 'action.hover',
              },
              '&.Mui-focused': {
                backgroundColor: 'background.paper',
              },
            },
          }}
        />
      </Paper>

      {/* Tabla de tipos de campaña */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        {datosCargados ? (
          <>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        backgroundColor: '#e3f2fd',
                        fontWeight: 700,
                        borderBottom: 2,
                        borderColor: 'primary.main',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}
                    >
                      Tipo de Campaña
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        backgroundColor: '#e3f2fd',
                        fontWeight: 700,
                        borderBottom: 2,
                        borderColor: 'primary.main',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}
                    >
                      Acciones
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tiposFiltrados.length > 0 ? (
                    tiposFiltrados
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((tipocampana) => (
                        <TableRow
                          key={tipocampana.tipocampanA_Id}
                          hover
                          sx={{
                            '&:hover': {
                              backgroundColor: '#f5f5f5',
                            },
                            '&:nth-of-type(even)': {
                              backgroundColor: 'action.hover',
                            },
                          }}
                        >
                          <TableCell>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {tipocampana.descritipocampana}
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Editar">
                              <IconButton
                                color="primary"
                                onClick={() => seleccionarTipoCampana(tipocampana)}
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Eliminar">
                              <IconButton
                                color="error"
                                onClick={() => mostrarDialogEliminar(tipocampana)}
                              >
                                <Delete />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2} align="center" sx={{ py: 8 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 2,
                            color: 'text.secondary',
                          }}
                        >
                          <Settings sx={{ fontSize: 64, opacity: 0.3 }} />
                          <Typography variant="h6">
                            No se encontraron tipos de campaña
                          </Typography>
                          <Typography variant="body2">
                            {term
                              ? 'Intenta con otros términos de búsqueda'
                              : 'Aún no hay tipos de campaña registrados'}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={tiposFiltrados.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Filas por página:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
              }
              sx={{
                borderTop: 1,
                borderColor: 'divider',
                '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                  fontWeight: 500,
                },
              }}
            />
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} thickness={4} />
            <Typography variant="h6" color="text.secondary">
              Cargando tipos de campaña...
            </Typography>
          </Box>
        )}
      </Paper>

      {/* Modal de confirmación para eliminar */}
      <Dialog
        open={openDialog}
        onClose={dialogHandleCloseX}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirmar eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar el tipo de campaña <strong>"{campanaElimNombre}"</strong>?
            <br />
            <strong>Esta acción no se puede deshacer.</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={dialogHandleCloseX}
            color="inherit"
          >
            Cancelar
          </Button>
          <Button 
            onClick={eliminarTipoCampana}
            color="error"
            variant="contained"
            startIcon={<Delete />}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TipoCampanaTb;
